import React, { useState, useEffect } from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
  pdf,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'
import { useParams } from 'react-router-dom'
import { getData } from '../../../api/indexedDBHandler'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 100,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 40,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 10,
    marginVertical: 2,
    lineHeight: 1.3,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  tableHeader: {
    backgroundColor: '#f2f2f2',
  },
  tableColHeader: {
    padding: 2,
    fontSize: 7,
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
})

const TournamentProtocolWeighing = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  averageFishWeight,
  biggestFish,
  isfinish,
}) => {
  console.log('TournamentProtocolWeighing', data)

  const getname = (team) => {
    const sp1sports_category = team[0]?.sports_category
      ? ' (' + team[0]?.sports_category + ')'
      : ''
    const sp1 = team[0]?.fio ? team[0]?.fio : ''

    const sp2sports_category = team[1]?.sports_category
      ? ' (' + team[1]?.sports_category + ')'
      : ''
    const sp2 = team[1]?.fio ? ', ' + team[1]?.fio : ''

    const sp3sports_category = team[2]?.sports_category
      ? ' (' + team[2]?.sports_category + ')'
      : ''
    const sp3 = team[2]?.fio ? ', ' + team[2]?.fio : ''

    return (
      sp1 +
      sp1sports_category +
      sp2 +
      sp2sports_category +
      sp3 +
      sp3sports_category
    )
  }
  // return (
  //   <Document style={{ margin: 40 }}>
  //     <Page size="A4" style={{ padding: 20, fontFamily: 'Roboto' }}>
  //       {/* Заголовок */}
  //       <View style={styles.header}>
  //         {mainLogo && <Image src={mainLogo} style={styles.logo} />}
  //         <View style={styles.headerTextContainer}>
  //           <Text style={styles.title}>{tournament.tournament_name}</Text>
  //           <Text style={styles.headerText}>
  //             Водоём:{' '}
  //             <Text style={{ fontWeight: 'bold' }}>
  //               {' '}
  //               {tournament.water_body}
  //             </Text>
  //           </Text>
  //           <Text style={styles.headerText}>
  //             Дата проведения:{' '}
  //             <Text style={{ fontWeight: 'bold' }}>
  //               {tournament.start_date} - {tournament.end_date}
  //             </Text>
  //           </Text>
  //           <Text style={styles.headerText}>
  //             Дата составления:{' '}
  //             <Text style={{ fontWeight: 'bold' }}>{date}</Text>
  //           </Text>
  //         </View>
  //       </View>
  //       <Text
  //         style={{
  //           fontSize: 12,
  //           fontWeight: 'bold',
  //           textAlign: 'center',
  //           marginBottom: 10,
  //         }}
  //       >
  //         {/* {tournament.status_cup == 'Турнир завершен' ? (
  //           <>ИТОГОВЫЙ ПРОТОКОЛ ПАРНЫХ СОРЕВНОВАНИЙ</>
  //         ) : (
  //           <> ПРОТОКОЛ ПАРНЫХ СОРЕВНОВАНИЙ</>
  //         )} */}
  //         ПРОТОКОЛ ВЗВЕШИВАНИЯ
  //       </Text>
  //       {/* <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 5 }}>
  //         Ловля карпа - командные соревнования (мужчины, женщины), номер-код
  //         дисциплины 0920021811Л
  //       </Text> */}
  //       <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 10 }}>
  //         Ловля карпа – парные соревнования (мужчины, женщины), код дисциплины
  //         0920151811Л
  //       </Text>

  //       <View>
  //         <View
  //           style={{
  //             width: '100%',
  //             borderStyle: 'solid',
  //             borderWidth: 0.3,
  //             borderColor: '#000',
  //             backgroundColor: '#f2f2f2',
  //           }}
  //         >
  //           <View style={{ flexDirection: 'row', alignItems: 'center' }}>
  //             <Text style={[styles.tableColHeader, { width: '6%' }]}># </Text>
  //             <Text
  //               style={[
  //                 styles.tableColHeader,
  //                 { width: '27%', textAlign: 'left' },
  //               ]}
  //             >
  //               Команда
  //             </Text>
  //             <Text
  //               style={[
  //                 styles.tableColHeader,
  //                 { width: '40%', textAlign: 'left' },
  //               ]}
  //             >
  //               Состав (Ф.И.О./разряд)
  //             </Text>
  //             <Text style={[styles.tableColHeader, { width: '9%' }]}>
  //               Номер очереди
  //             </Text>

  //             <Text style={[styles.tableColHeader, { width: '9%' }]}>
  //               Группа
  //             </Text>
  //             <Text style={[styles.tableColHeader, { width: '9%' }]}>
  //               Сектор
  //             </Text>
  //           </View>
  //         </View>
  //       </View>
  //       {data.map((item, index) => {
  //         if (item.team)
  //           return (
  //             <View
  //               key={index}
  //               style={{
  //                 borderWidth: 0.3,
  //                 borderColor: '#000',
  //                 marginBottom: 0,
  //               }}
  //             >
  //               <View
  //                 style={{
  //                   flexDirection: 'row',
  //                   alignItems: 'center',
  //                   backgroundColor: index < 3 ? '#fff' : '#fff',
  //                 }}
  //               >
  //                 <Text
  //                   style={{
  //                     width: '6%',
  //                     textAlign: 'center',
  //                     fontSize: 8,
  //                     fontWeight: 'bold',
  //                     padding: 2,
  //                   }}
  //                 >
  //                   {index + 1}
  //                 </Text>

  //                 <Text style={{ width: '27%', fontSize: 8, padding: 2 }}>
  //                   {item.team?.team_name_ru}
  //                 </Text>
  //                 <Text style={{ width: '40%', fontSize: 8, padding: 2 }}>
  //                   {getname(item.athlete)}
  //                 </Text>

  //                 <Text
  //                   style={{
  //                     width: '9%',
  //                     textAlign: 'center',
  //                     fontSize: 8,
  //                     padding: 2,
  //                   }}
  //                 >
  //                   {item.team?.queue}
  //                 </Text>
  //                 <Text
  //                   style={{
  //                     width: '9%',
  //                     textAlign: 'center',
  //                     fontSize: 8,
  //                     padding: 2,
  //                   }}
  //                 >
  //                   {item.team?.zona}
  //                 </Text>
  //                 <Text
  //                   style={{
  //                     width: '9%',
  //                     textAlign: 'center',
  //                     fontSize: 8,
  //                     padding: 2,
  //                   }}
  //                 >
  //                   {item.team?.sector}
  //                 </Text>
  //               </View>
  //             </View>
  //           )
  //       })}
  //       {/* Подписи */}
  //       <View
  //         style={{
  //           flexDirection: 'row',
  //           justifyContent: 'space-between',
  //           marginTop: 40,
  //         }}
  //       >
  //         <View
  //           style={{
  //             width: '35%',
  //             borderTopWidth: 1,
  //             borderTopStyle: 'solid',
  //             textAlign: 'center',
  //           }}
  //         >
  //           <Text
  //             style={{
  //               fontSize: '8px',
  //               textAlign: 'center',
  //             }}
  //           >
  //             {administrator[0]?.surname +
  //               ' ' +
  //               administrator[0]?.name +
  //               ' ' +
  //               administrator[0]?.patronymic +
  //               ' (' +
  //               administrator[0]?.role +
  //               ', ' +
  //               administrator[0]?.rank +
  //               ') '}
  //           </Text>
  //         </View>
  //         <View
  //           style={{
  //             width: '35%',
  //             borderTopWidth: 1,
  //             borderTopStyle: 'solid',
  //             textAlign: 'center',
  //           }}
  //         >
  //           <Text
  //             style={{
  //               fontSize: '8px',
  //               textAlign: 'center',
  //             }}
  //           >
  //             {administrator[1]?.surname +
  //               ' ' +
  //               administrator[1]?.name +
  //               ' ' +
  //               administrator[1]?.patronymic +
  //               ' (' +
  //               administrator[1]?.role +
  //               ', ' +
  //               administrator[1]?.rank +
  //               ') '}
  //           </Text>
  //         </View>
  //         <View
  //           style={{
  //             width: '20%',
  //             borderTopWidth: 1,
  //             borderTopStyle: 'solid',
  //             textAlign: 'center',
  //           }}
  //         >
  //           <Text
  //             style={{
  //               fontSize: '8px',
  //               textAlign: 'center',
  //             }}
  //           >
  //             Дата
  //           </Text>
  //         </View>
  //       </View>
  //       {/* Логотипы партнеров */}
  //       <View style={styles.logoContainer}>
  //         {allLogo.map((item, index) => (
  //           <Image key={index} src={item.url} style={styles.logoSmall} />
  //         ))}
  //       </View>
  //     </Page>
  //   </Document>
  // )
  return (
    <Document style={{ margin: 40 }}>
      <Page size="A4" style={{ padding: 20, fontFamily: 'Roboto' }}>
        {/* Заголовок */}
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {' '}
                {tournament.water_body}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>

        <Text
          style={{
            fontSize: 12,
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          ПРОТОКОЛ ВЗВЕШИВАНИЯ
        </Text>

        <View>
          <View
            style={{
              width: '100%',
              borderStyle: 'solid',
              borderWidth: 0.3,
              borderColor: '#000',
              backgroundColor: '#f2f2f2',
            }}
          >
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text style={[styles.tableColHeader, { width: '5%' }]}>
                Сектор
              </Text>

              <Text
                style={[
                  styles.tableColHeader,
                  { width: '27%', textAlign: 'left' },
                ]}
              >
                Команда
              </Text>

              <Text style={[styles.tableColHeader, { width: '7%' }]}>
                Кол-во
              </Text>
              <Text style={[styles.tableColHeader, { width: '7%' }]}>Вес</Text>
              <Text style={[styles.tableColHeader, { width: '54%' }]}>
                Список рыб
              </Text>
            </View>
          </View>
        </View>
        {data.map((item, index) => (
          <View
            key={index}
            style={{ borderWidth: 0.3, borderColor: '#000', marginBottom: 0 }}
          >
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor: index < 3 ? '#fff' : '#fff',
              }}
            >
              <Text
                style={{
                  width: '6%',
                  textAlign: 'center',
                  fontSize: 8,
                  padding: 2,
                }}
              >
                {item.sector}
              </Text>
              <Text style={{ width: '27%', fontSize: 8, padding: 2 }}>
                <Text style={{ fontWeight: 'bold' }}>{item.teamName}</Text>
                {'\n'}
                <Text>{item.sp}</Text>
              </Text>

              <Text
                style={{
                  width: '7%',
                  textAlign: 'center',
                  fontSize: 8,
                  padding: 2,
                }}
              >
                {item.fishCount}
              </Text>
              <Text
                style={{
                  width: '7%',
                  textAlign: 'center',
                  fontSize: 8,
                  padding: 2,
                }}
              >
                {item.totalWeight}
              </Text>

              <Text
                style={{
                  width: '54%',

                  fontSize: 8,
                  padding: 2,
                }}
              >
                {item.fishList.join(', ')}
              </Text>
            </View>
          </View>
        ))}
        {/* <View style={{ borderWidth: 0.1, borderColor: '#fff', marginBottom: 0 }}>
        <View
          style={{
            flexDirection: 'row',
            backgroundColor: '#fff',
          }}
        >
          <Text
            style={{
              width: '7%',
              textAlign: 'center',
              fontSize: 8,
              fontWeight: 'bold',
              padding: 2,
            }}
          ></Text>

          <Text
            style={{
              textAlign: 'right',
              width: '25%',
              fontSize: 8,
              padding: 2,
            }}
          >
            ВСЕГО
          </Text>

          <Text
            style={{
              width: '8%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          >
            12 999
          </Text>
          <Text
            style={{
              width: '9%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          >
            123 000 000
          </Text>
        </View>
      </View> */}

        {/* Подписи */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 40,
          }}
        >
          <View
            style={{
              width: '35%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              {administrator[0]?.surname +
                ' ' +
                administrator[0]?.name +
                ' ' +
                administrator[0]?.patronymic +
                ' (' +
                administrator[0]?.role +
                ', ' +
                administrator[0]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '35%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              {administrator[1]?.surname +
                ' ' +
                administrator[1]?.name +
                ' ' +
                administrator[1]?.patronymic +
                ' (' +
                administrator[1]?.role +
                ', ' +
                administrator[1]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '20%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              Дата
            </Text>
          </View>
        </View>

        {/* Логотипы партнеров */}
        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

const ProtocolComWeighing = ({ isProtocolWeighinfdCallback }) => {
  const [stage, setStage] = useState(null)
  const [totalFishCount, setTotalFishCount] = useState(null)
  const [totalWeight, setTotalWeight] = useState(null)
  const [averageFishWeight, setAverageFishWeight] = useState(null)
  const [biggestFish, setBiggestFish] = useState(null)
  const [isFinish, setIsFinish] = useState(null)
  const [tournament, setTournament] = useState(null)
  const [allLogos, setAllLogos] = useState([])
  const [administrator, setAdministrator] = useState([])
  const [pdfUrl, setPdfUrl] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const { id } = useParams()

  const getname = (teamData, t) => {
    if (t.competition_type == 'Рейтинговое соревнование') {
      return teamData?.team_name_ru
    }
    return teamData?.preferred_name == 'en'
      ? teamData?.team_name_en
        ? teamData?.team_name_en
        : teamData?.team_name_ru
      : teamData?.team_name_ru
  }

  const fetchData = async () => {
    setIsLoading(true)
    try {
      let tournamentData = null

      // Получаем данные турнира
      const resultsT = await getData('tournaments', 'id', id)
      if (resultsT.length > 0) {
        const { value } = resultsT[0]
        setTournament(value)
        tournamentData = value
        setIsFinish(value.status_cup === 'Турнир завершен')
        setAllLogos(Object.values(value.sponsor || []))
        setAdministrator(Object.values(value.administrator || []))
      }

      // Получаем данные команд
      const resultsU = await getData('teams', 'id', id)
      if (resultsU.length > 0) {
        const { value } = resultsU[0]
        const teamsArray = Object.values(value)
        const filteredTeams = teamsArray.filter(
          (teamEntry) =>
            teamEntry !== null &&
            typeof teamEntry === 'object' &&
            teamEntry.team?.status === 'Заявка одобрена' &&
            teamEntry.team?.status_location === 1
        )

        // Создаем объект с информацией о командах
        const teams = {}
        filteredTeams.forEach((team) => {
          const sp1sports_category = team.athlete[0]?.sports_category
            ? ' (' + team.athlete[0]?.sports_category + ')'
            : ''
          const sp1 = team.athlete[0]?.fio ? team.athlete[0]?.fio : ''

          const sp2sports_category = team.athlete[1]?.sports_category
            ? ' (' + team.athlete[1]?.sports_category + ')'
            : ''
          const sp2 = team.athlete[1]?.fio ? ', ' + team.athlete[1]?.fio : ''

          const sp3sports_category = team.athlete[2]?.sports_category
            ? ' (' + team.athlete[2]?.sports_category + ')'
            : ''
          const sp3 = team.athlete[2]?.fio ? ', ' + team.athlete[2]?.fio : ''

          const name = getname(team.team, tournamentData)
            ? getname(team.team, tournamentData)
            : ''

          teams[team.team.id] = {
            team: name,
            sector: team.team.sector,
            sp:
              sp1 +
              sp1sports_category +
              sp2 +
              sp2sports_category +
              sp3 +
              sp3sports_category,
          }
        })

        // Получаем данные этапов
        const resultsS = await getData('stage', 'id', id)
        if (resultsS.length > 0) {
          const { value } = resultsS[0]
          const stageArray = Object.values(value)
          const filteredStageArrays = stageArray.filter(
            (teamEntry) => teamEntry !== null && typeof teamEntry === 'object'
          )
          console.log('stageArray', stageArray)
          const data = filteredStageArrays
          const lastWeighing = Math.max(
            ...data[0].map((entry) => entry.weighing)
          )

          // Фильтруем данные по последнему взвешиванию
          const lastWeighingData = data[0].filter(
            (entry) => entry.weighing === lastWeighing
          )
          console.log('lastWeighingData', lastWeighingData)
          // Создаем объект для хранения протокола
          const weighingProtocol = {}

          // Обрабатываем каждую запись последнего взвешивания
          lastWeighingData.forEach((entry) => {
            if (!entry.teamId) return
            if (entry.fishList && entry.fishList[0]?.weight === 0) return

            // Создаем запись для команды, если её еще нет
            if (!weighingProtocol[entry.teamId]) {
              weighingProtocol[entry.teamId] = {
                teamName: entry.teamName
                  ? entry.teamName
                  : teams[entry.teamId]?.team || '',
                sp: teams[entry.teamId]?.sp || '',
                sector: teams[entry.teamId]?.sector || '',
                totalWeight: 0,
                fishCount: 0,
                biggestFish: 0,
                fishList: [],
                weighingNumber: lastWeighing,
              }
            }

            // Если есть рыба - добавляем в протокол
            if (entry.fishList && entry.fishList.length > 0) {
              const weight = entry.fishList.reduce(
                (sum, fish) => sum + fish.weight,
                0
              )
              const biggestFish = Math.max(
                ...entry.fishList.map((fish) => fish.weight)
              )

              weighingProtocol[entry.teamId].totalWeight += weight
              weighingProtocol[entry.teamId].fishCount += entry.fishList.length
              weighingProtocol[entry.teamId].biggestFish = Math.max(
                weighingProtocol[entry.teamId].biggestFish,
                biggestFish
              )

              // Добавляем каждую рыбу с деталями
              entry.fishList.forEach((fish) => {
                const fishtype = fish.type === 'карп' ? '(к)' : '(а)'
                const fishEntry = fish.weight + '' + fishtype
                weighingProtocol[entry.teamId].fishList.push(fishEntry)
              })
            }
          })
          console.log('weighingProtocol', weighingProtocol)
          // Сортируем команды по общему весу
          const sortedProtocol = Object.values(weighingProtocol).sort(
            (a, b) =>
              b.totalWeight - a.totalWeight ||
              b.fishCount - a.fishCount ||
              b.biggestFish - a.biggestFish
          )
          console.log('sortedProtocol', sortedProtocol)
          setStage(sortedProtocol)
        }
      }
    } catch (error) {
      console.error('Ошибка при загрузке данных:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleGenerateAndDownload = async () => {
    await fetchData()

    if (!stage || !tournament) return
    console.log('stage', stage)
    // Создаем PDF
    const pdfDoc = (
      <TournamentProtocolWeighing
        allLogo={allLogos}
        mainLogo={getLogoUrl(tournament?.logocup)}
        data={stage}
        administrator={administrator}
        tournament={tournament}
        date={dateNowProtocol(new Date())}
        totalFishCount={totalFishCount}
        totalWeight={totalWeight}
        averageFishWeight={averageFishWeight}
        biggestFish={biggestFish}
        isfinish={isFinish}
      />
    )

    // Генерируем blob
    const blob = await pdf(pdfDoc).toBlob()

    // Создаем URL для скачивания
    const url = URL.createObjectURL(blob)

    // Создаем временную ссылку для скачивания
    const a = document.createElement('a')
    a.href = url
    a.download = `протокол_взвешивания_${dateNowProtocol(new Date())}.pdf`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    // Сохраняем URL для отображения миниатюры
    setPdfUrl(url)

    // Отправляем на сервер
    await uploadPdfToServer(blob)
  }

  const uploadPdfToServer = async (blob) => {
    try {
      const formData = new FormData()
      formData.append(
        'pdf',
        blob,
        `протокол_взвешивания_${dateNowProtocol(new Date())}.pdf`
      )
      formData.append('id', id)
      formData.append('isPost', 3)

      formData.append('type', 'ProtocolWeighing')
      const response = await fetch(
        'https://www.admin-protocarp.ru/php/uploads/upload.php',
        {
          method: 'POST',
          body: formData,
        }
      )

      if (response.ok) {
        const result = await response.json()
        // Обновляем URL на серверный, если нужно
        setPdfUrl(result.fileUrl)
        isProtocolWeighinfdCallback(result.fileUrl)
      } else {
        console.error('Ошибка загрузки файла на сервер')
      }
    } catch (error) {
      console.error('Ошибка при загрузке на сервер:', error)
    }
  }

  return (
    <div>
      <Button
        variant="contained"
        size="small"
        onClick={handleGenerateAndDownload}
        sx={{ mt: 1 }}
      >
        Скачать
      </Button>

      {pdfUrl && (
        <div style={{ marginTop: '20px' }}>
          <Typography variant="body2" color="text.secondary">
            Протокол:
          </Typography>
          <iframe
            src={pdfUrl}
            width="120"
            height="160"
            style={{ border: '1px solid #ccc' }}
            title="Протокол взвешивания"
          />
          <Typography component="div" variant="body2">
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
              Открыть в новой вкладке
            </a>
          </Typography>
        </div>
      )}
    </div>
  )
}

export default ProtocolComWeighing
